const SAME_KEY = {
  LIVE: 'live',
  RESULTS: 'results',
};

export const ALTENAR_PAGES = {
  ...SAME_KEY,
  ALL_SPORTS: 'allSports',
  BET_HISTORY: 'betHistory',
  CATEGORY: 'category',
  CHAMPIONSHIP: 'championship',
  EVENT: 'event',
  LIVE_EVENT: 'liveEvent',
  MY_BETS: 'myBets',
  OVERVIEW: 'overview',
  SETTINGS: 'settings',
  SPORT: 'sport',
};

const ROUTES = {
  ...SAME_KEY,
  MY_BETS: 'my-bets',
  SPORTSBOOK: 'sportsbook',
};

export const ALTENAR_MAP_ROUTES = {
  [ALTENAR_PAGES.LIVE]: ROUTES.LIVE,
  [ALTENAR_PAGES.OVERVIEW]: ROUTES.SPORTSBOOK,
  [ALTENAR_PAGES.RESULTS]: ROUTES.RESULTS,
};

export const ALTENAR_PAGE_BY_ROUT = {
  [ROUTES.LIVE]: ALTENAR_PAGES.LIVE,
  [ROUTES.RESULTS]: ALTENAR_PAGES.RESULTS,
  [ROUTES.SPORTSBOOK]: ALTENAR_PAGES.OVERVIEW,
};

export const ALTENAR_PAGE_BASE_ROUTE = {
  [ALTENAR_PAGES.ALL_SPORTS]: ROUTES.SPORTSBOOK,
  [ALTENAR_PAGES.BET_HISTORY]: ROUTES.SPORTSBOOK,
  [ALTENAR_PAGES.CATEGORY]: ROUTES.SPORTSBOOK,
  [ALTENAR_PAGES.CHAMPIONSHIP]: ROUTES.SPORTSBOOK,
  [ALTENAR_PAGES.EVENT]: ROUTES.SPORTSBOOK,
  [ALTENAR_PAGES.LIVE]: ROUTES.LIVE,
  [ALTENAR_PAGES.LIVE_EVENT]: ROUTES.LIVE,
  [ALTENAR_PAGES.MY_BETS]: ROUTES.MY_BETS,
  [ALTENAR_PAGES.OVERVIEW]: ROUTES.SPORTSBOOK,
  [ALTENAR_PAGES.RESULTS]: ROUTES.RESULTS,
  [ALTENAR_PAGES.SETTINGS]: ROUTES.SPORTSBOOK,
  [ALTENAR_PAGES.SPORT]: ROUTES.SPORTSBOOK,
};

export const ALTENAR_PAGE_PARAMS = {
  [ALTENAR_PAGES.CATEGORY]: ['sportId', 'categoryIds'],
  [ALTENAR_PAGES.CHAMPIONSHIP]: ['sportId', 'categoryIds', 'championshipIds'],
  [ALTENAR_PAGES.EVENT]: ['sportId', 'categoryIds', 'championshipIds', 'eventId'],
  [ALTENAR_PAGES.LIVE]: ['sportId'],
  [ALTENAR_PAGES.LIVE_EVENT]: ['sportId', 'categoryIds', 'championshipIds', 'eventId'],
  [ALTENAR_PAGES.SPORT]: ['sportId'],
};

export const ALTENAR_ARRAY_PARAM_KEYS = ['categoryIds', 'championshipIds', 'sportIds'];
